import { $framework } from "@opendash/core";
import { makeAutoObservable, runInAction } from "mobx";
import { ProjectsViews, ProjectsViewType } from "../types/ProjectsViews";

type StorageValues = "currentView";

export class ProjectsManager {
  private static readonly storagePrefix: string = "projects";

  private static getStorageKey(key: string) {
    return `${ProjectsManager.storagePrefix}-${key}`;
  }

  private views: ProjectsViews = ["list", "card"];
  private _currentView: ProjectsViewType = "list";

  constructor() {
    makeAutoObservable(this);
    this._currentView =
      this.getStorageValue<ProjectsViewType>("currentView") || "list";
  }

  get viewOptions() {
    return this.views.map((view) => {
      return {
        translationKey: "maintenance:project.overview.view." + view,
        value: view,
      };
    });
  }

  get currentView() {
    return this._currentView;
  }

  getStorageValue<T>(key: StorageValues): T | undefined {
    return $framework.services.DeviceStorageService._getSync<T>(
      ProjectsManager.getStorageKey(key)
    );
  }

  setStorageValue<T>(key: StorageValues, value: T) {
    $framework.services.DeviceStorageService.set<T>(
      ProjectsManager.getStorageKey(key),
      value
    );
  }

  setView(view: ProjectsViewType) {
    runInAction(() => {
      this.setStorageValue<ProjectsViewType>("currentView", view);
      this._currentView = view;
    });
  }
}
